import React, { useEffect, useState } from "react";
import { Label, RequiredRule } from 'devextreme-react/form';
import { DateBox, NumberBox, TextBox } from "devextreme-react";
import { function_ABM_EEX_Clientes_InsertarBasico, function_ABM_EEX_Clientes_LeerPorDNISinPassword } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import { FormateoFechaPara_ddMMyyyy, FormateoFechaPara_yyyyMMdd } from "neftis7_apicaller/src/funciones/Varios";

const LV_EEX_Participante = ({ index, onIdClienteChange = () => { } }) => {
    const [idCliente, setIdCliente] = useState(0);
    const [cuit, setCUIT] = useState("");
    const [nombre, setNombre] = useState("");
    const [apellido, setApellido] = useState("");
    const [participante, setParticipante] = useState("");
    const [fechaNacimiento, setFechaNacimiento] = useState(new Date());
    const [camposDeCarga, setCamposDeCarga] = useState(false);
    const [sinCampos, setSinCampos] = useState(true);
    const [cierreEnProceso, setCierreEnProceso] = useState(false);

    useEffect(() => {
        const obtenerCliente = async () => {
            if (!cuit || cuit === "") {
                setSinCampos(true);
                return;
            }

            setSinCampos(false);
            const resultClientes = await function_ABM_EEX_Clientes_LeerPorDNISinPassword(cuit);

            if (resultClientes?.data?.length > 0) {
                setCamposDeCarga(false);
                setIdCliente(resultClientes.data[0].IdCliente);
                setNombre(resultClientes.data[0].Nombre);
                setApellido(resultClientes.data[0].Apellido);
                setFechaNacimiento(resultClientes.data[0].FechaNacimiento);

                setParticipante(`Participante: ${resultClientes.data[0].Nombre} ${resultClientes.data[0].Apellido}`);
            } else {
                setCamposDeCarga(true);
                setIdCliente(0);
                setNombre("");
                setApellido("");
                setFechaNacimiento(new Date());
                setParticipante("");
            }
        };

        obtenerCliente();
    }, [cuit]);

    useEffect(() => {
        onIdClienteChange(idCliente);
    }, [idCliente]);

    const handleOnClickCrearParticipante = async () => {
        const hoy = new Date();
        const unAnioAtras = new Date();
        unAnioAtras.setFullYear(hoy.getFullYear() - 1);

        if (!nombre) {
            alert("Falta el Nombre.");
            return;
        }

        if (!apellido) {
            alert("Falta el Apellido.");
            return;
        }

        if (fechaNacimiento > unAnioAtras) {
            alert("La Fecha de Nacimiento es incorrecta.");
            return;
        }

        try {
            if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
            setCierreEnProceso(true);

            const resultCliente = await function_ABM_EEX_Clientes_InsertarBasico(apellido, nombre, cuit,
                await FormateoFechaPara_yyyyMMdd(fechaNacimiento), cuit, "", "")

            alert("Has registrado correctamente a " + nombre + "!.");

            const nuevoId = resultCliente.data.codigoGenerado;

            setIdCliente(nuevoId);
            setCamposDeCarga(false);
            setParticipante(`Participante: ${nombre} ${apellido}`);

        } catch (error) {
            alert(nombre + ", hubo problemas en el registro.");
        } finally {
            setCierreEnProceso(false); // Se habilita el botón de nuevo
        }
    }

    return (
        <div className="LV-GroupBox-div LV-FlexContainer" style={{ width: '100%', gap: '20px' }}>
            PARTICIPANTE {index + 1}

            <NumberBox value={idCliente} onValueChanged={e => setIdCliente(e.value)} visible={false} />

            <NumberBox
                label="D.N.I."
                value={cuit}
                width={120}
                onValueChanged={e => setCUIT(e.value)}>
                <Label text="D.N.I." />
                <RequiredRule message="Indicar el D.N.I. es obligatorio." />
            </NumberBox>

            <TextBox
                label="Nombre"
                value={nombre}
                width={300}
                onValueChanged={e => setNombre(e.value)}
                visible={camposDeCarga && !sinCampos}>
                <Label text="Nombre" />
                <RequiredRule message="Indicar el Nombre es obligatorio." />
            </TextBox>

            <TextBox
                label="Apellido"
                value={apellido}
                width={300}
                onValueChanged={e => setApellido(e.value)}
                visible={camposDeCarga && !sinCampos}>
                <Label text="Apellido" />
                <RequiredRule message="Indicar el Apellido es obligatorio." />
            </TextBox>

            <TextBox
                label="Participante"
                value={participante}
                width={800}
                visible={!camposDeCarga && !sinCampos}
                readOnly={true}>
            </TextBox>

            <span style={{ visibility: camposDeCarga && !sinCampos ? 'visible' : 'hidden', display: 'block', marginBottom: '5px' }}>
                Fecha de Nacimiento
            </span>
            <DateBox
                displayFormat="dd/MM/yyyy"
                value={fechaNacimiento}
                onValueChanged={e => setFechaNacimiento(e.value)}
                visible={!sinCampos}
                readOnly={!camposDeCarga}
                width={120}
            />

            <LVButtonAccion
                Disabled={cierreEnProceso} Texto="CREAR PARTICIPANTE" Ancho={180} onClick={handleOnClickCrearParticipante} visible={camposDeCarga && !sinCampos} />
        </div>
    );
}

export default LV_EEX_Participante;